import { render, staticRenderFns } from "./TeacherView.vue?vue&type=template&id=458aa56c"
import script from "./TeacherView.vue?vue&type=script&lang=js"
export * from "./TeacherView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports